module.exports = "/_next/static/images/icons-e5a8d4a103531096b15234d73eceff45.svg";